import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { useGetContentProgress } from "@modules/content/hooks/useGetContentProgress";
import { defaultPageSize } from "@modules/content/helpers/content";
import {
  HorizontalList,
  HorizontalListItemParameters,
  HorizontalListParameters,
} from "@components/layouts/content/HorizontalList";
import { useLockedContents } from "../hooks/useLockedContent";
import { ExtraProps } from ".";
import { useEffect } from "react";
import {
  getCustomerQuota,
  setIsCreditModalOpen,
  useAppSelector,
} from "@lib/stores";
import { SVG } from "@components/items/common/SVG";
import TranslatedText from "@components/items/display/TranslatedText";

const Component = createComponentElement<{
  extraProps?: ExtraProps;
}>((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<HorizontalListParameters, HorizontalListItemParameters>(
    {
      ...props,
      pageNumber: 1,
      pageSize: defaultPageSize,
    },
    ref
  );

  const customerQuota = useAppSelector((state) => state.payment.customerQuota);

  useEffect(() => {
    getCustomerQuota();
  }, []);

  return (
    <div
      className="mb-10 ms-8 flex w-[440px] cursor-pointer flex-col gap-2 rounded-xl border border-[#208FFF] bg-[#D4EAFF] p-5"
      onClick={() => {
        setIsCreditModalOpen(true);
      }}
    >
      <div className="flex gap-2 text-[20px] font-medium">
        <TranslatedText text="full-books.book-balance" />
        <SVG src="/assets/icons/coin.svg" className="h-[32px] w-[32px]" />
        <div>{customerQuota?.data?.remainingCredit}</div>
      </div>
      <TranslatedText
        className="text-[18px]"
        text="full-books.book-balance-description"
      />
    </div>
  );
});

export const CreditCardComponent: ContentComponent = {
  identifier: "COM:CREDIT:CARD",
  component: Component,
};
